var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJiraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2109 22.7456L25.933 3.46761L24.065 1.59961L9.55295 16.1116L2.91695 22.7456C2.58549 23.0788 2.39941 23.5296 2.39941 23.9996C2.39941 24.4696 2.58549 24.9204 2.91695 25.2536L16.1749 38.5116L24.065 46.3996L38.575 31.8876L38.8009 31.6636L45.2109 25.2636C45.3771 25.0987 45.5089 24.9026 45.5989 24.6865C45.6888 24.4704 45.7352 24.2387 45.7352 24.0046C45.7352 23.7705 45.6888 23.5388 45.5989 23.3227C45.5089 23.1066 45.3771 22.9105 45.2109 22.7456ZM24.065 30.6236L17.441 23.9996L24.065 17.3756L30.687 23.9996L24.065 30.6236Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0645 17.3758C21.9812 15.293 20.8068 12.4705 20.7979 9.52471C20.7889 6.57891 21.946 3.74925 24.0165 1.65381L9.52246 16.1418L17.4105 24.0298L24.0645 17.3758Z",
    fill: "url(#paint0_linear_1057_3135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7054 23.9814L24.0654 30.6234C26.1566 32.7151 27.3313 35.5517 27.3313 38.5094C27.3313 41.4671 26.1566 44.3038 24.0654 46.3954L38.5994 31.8694L30.7054 23.9814Z",
    fill: "url(#paint1_linear_1057_3135)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1057_3135",
    x1: 22.8785,
    y1: 10.6738,
    x2: 13.6285,
    y2: 19.9218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1057_3135",
    x1: 25.3294,
    y1: 37.2454,
    x2: 34.5614,
    y2: 28.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIcon);
export default __webpack_public_path__ + "static/media/jira-icon.0cee632b8ed66a11f5b15f9d8d6eb777.svg";
export { ForwardRef as ReactComponent };